// extracted by mini-css-extract-plugin
module.exports = {"questionTag":"question-components_questionTag__U6PcR","questionTagSelected":"question-components_questionTagSelected__WaZr9"};